export default [
  {
    path: '/login',
    name: 'login',
    props: { showError: false },
    component: () => import(/* webpackChunkName: "login" */ '../../views/v2/LoginView.vue')
  },
  {
    path: '/login/error/:sessionId?',
    name: 'login-error',
    props: { showError: true },
    component: () => import(/* webpackChunkName: "login" */ '../../views/v2/LoginView.vue')
  },
  {
    path: '/login/confirm/:sessionId?',
    name: 'login-confirm',
    props: { showConfirm: true },
    component: () => import(/* webpackChunkName: "login" */ '../../views/v2/LoginView.vue')
  },
  {
    path: '/login/link/success/:sessionId?',
    name: 'login-link-success',
    props: { showLinkSuccess: true },
    component: () => import(/* webpackChunkName: "login" */ '../../views/v2/LoginView.vue')
  },
  /* END LOGIN */
  {
    path: '/customer/signup',
    name: 'customer-signup',
    component: () => import(/* webpackChunkName: "signup" */ '../../views/v2/SignupView.vue')
  },
  {
    path: '/customer/signup/error',
    name: 'customer-signup-terms-and-conditions-error',
    component: () => import(/* webpackChunkName: "signup" */ '../../views/v2/ErrorView.vue')
  },
  {
    path: '/customer/signup/error/:sessionId',
    name: 'customer-signup-error',
    // props: { showError: true },
    component: () => import(/* webpackChunkName: "signup" */ '../../views/v2/ErrorView.vue')
  },
  {
    path: '/customer/signup/nocode/:sessionId',
    name: 'customer-signup-nocode',
    props: { showFormCode: true },
    component: () => import(/* webpackChunkName: "signup" */ '../../views/v2/SignupView.vue')
  },
  {
    path: '/customer/signup/recovery/:status/:sessionId',
    name: 'customer-signup-recovery',
    props: { showRecovery: true },
    component: () => import(/* webpackChunkName: "signup" */ '../../views/v2/SignupView.vue')
  },
  {
    path: '/customer/signup/exists/:status/:customerBase64/:sessionId',
    name: 'customer-signup-revocery-with-customer',
    component: () => import(/* webpackChunkName: "signup" */ '../../views/v2/SignupExistView.vue')
  },
  {
    path: '/customer/signup/terms-and-conditions/:hash',
    name: 'customer-signup-terms-and-conditions',
    component: () => import(/* webpackChunkName: "signup" */ '../../views/v2/CustomerTerms.vue')
  },
  {
    path: '/customer/signup/terms-and-conditions/:hash/:validation',
    name: 'customer-multiple-terms-and-conditions',
    props: { flow: 'signup-multiple-brand' },
    component: () => import(/* webpackChunkName: "signup" */ '../../views/v2/ClubTerms.vue')
  },
  /* CLUB TERMS  */
  {
    path: '/club/terms-and-conditions/:sessionId',
    name: 'club-terms-and-conditions',
    props: { flow: 'invite-single-brand' },
    component: () => import(/* webpackChunkName: "club" */ '../../views/v2/ClubTerms.vue')
  },
  /* FAVORITE PHARMAPCY */
  {
    path: '/club/favourite/:sessionId?',
    name: 'favorite-pharmacy',
    component: () => import(/* webpackChunkName: "favorite-pharmacy" */ '../../views/v2/FavPharmacyView.vue')
  },
  /* RESET PASSWORD  */
  {
    path: '/forgot',
    name: 'reset-password-step1',
    component: () => import(/* webpackChunkName: "reset-password-step1" */ '../../views/v2/ResetPasswordStep1.vue')
  },
  {
    path: '/forgot/error/:sessionId',
    name: 'reset-password-step1-error',
    props: { showError: true },
    component: () => import(/* webpackChunkName: "reset-password-step1" */ '../../views/v2/ResetPasswordStep1.vue')
  },
  {
    path: '/forgot/success/:sessionId',
    name: 'reset-password-step1-confirm',
    props: { showSuccess: true },
    component: () => import(/* webpackChunkName: "reset-password-step1" */ '../../views/v2/ResetPasswordStep1.vue')
  },
  {
    path: '/reset/:sessionId',
    name: 'reset-password-step2',
    component: () => import(/* webpackChunkName: "reset-password-step2" */ '../../views/v2/ResetPasswordStep2.vue')
  },
  {
    path: '/reset/success/:sessionId',
    name: 'reset-password-step2-success',
    props: { showSuccess: true },
    component: () => import(/* webpackChunkName: "reset-password-step2" */ '../../views/v2/ResetPasswordStep2.vue')
  },
  {
    path: '/reset/error/:sessionId',
    name: 'reset-password-step2-error',
    props: { showError: true },
    component: () => import(/* webpackChunkName: "reset-password-step2" */ '../../views/v2/ResetPasswordStep2.vue')
  },
  // ERROR
  {
    path: '/error',
    name: 'error',
    component: () => import(/* webpackChunkName: "error" */ '../../views/v2/ErrorView.vue')
  },
  {
    path: '/error-500',
    name: 'error500',
    component: () => import(/* webpackChunkName: "error-500" */ '../../views/v2/ErrorView.vue')
  }
]
